window.primaryColor = '#3498db';
require('./common.js');
require('../pages/outings/init.js');
require('stylesheets/theme/outings');
